import React from "react";
import Banner from "../components/Banner";
import CoinsTable from "../components/CoinsTable";

export default function Homepage() {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
}
